import nl_NL from '@/translations/nl_NL';
import en_US from '@/translations/en_US';

export default {
  nl_NL,
  en_US,
};
